module.exports = __webpack_public_path__ + "TheResultsOfTheShanghaiMunicipalEducationCommittee.png?aa584c2822cf6fdb767ccc8725b75473";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Solution/Case/TheResultsOfTheShanghaiMunicipalEducationCommittee.png
// module id = 178
// module chunks = 0